<template>
  <div class="row" id="row-suggestions">
    <div class="col-lg-6 col-md-6 col-xs-12 mpx-0" id="first-col-suggestions">
      <p class="title" v-if="suggestions.length">{{ transMenu.item38 }}</p>
      <p
        v-for="(suggestion, index) in suggestions"
        class="result"
        @click="sendToSearch(suggestion.term)"
      >
        {{ suggestion.term0 }}<b>{{ suggestion.term1 }}</b
        >{{ suggestion.term2 }}
      </p>
      <p class="title mt-4" v-if="categories.length">{{ transMenu.item39 }}</p>
      <div id="my-category-suggestions">
        <li v-for="(category, index) in categories" class="li-cat-name">
          <a class="category" :href="category.href"
            ><span v-if="category.route">{{ category.route }}</span>
            {{ category.translation ? category.translation.name : "null" }}</a
          >
        </li>
      </div>
    </div>
    <div class="col-lg-6 col-md-6 col-xs-12 mpx-0" id="second-col-suggestions">
      <p class="title" v-if="products.length">{{ transMenu.item37 }}</p>
      <div id="my-product-suggestions">
        <a
          v-for="(product, index) in products"
          class="product-suggestion"
          :href="product.href"
        >
          <img :src="product.images[0].image" />
          <div class="item_kodemoon">
            <h5 class="ref" v-if="product.alias_code">
              {{ product.alias_code }}
            </h5>
            <h5 class="ref" v-else>{{ product.erp_reference }}</h5>
            <h4 class="desc">{{ product.translation.name }}</h4>

            <div class="d-flex" v-if="parseFloat(product.discount_) > 0">
              <div class="container-pvp">
                <p class="pvp-title">{{ transPeralbaPro.item132 }}</p>
                <div class="d-flex">
                  <p class="pvp-value">
                    {{ product.price_without_discount_ | currency }}
                  </p>
                  <span class="offer">-{{ product.discount_ | percentage }}</span>
                </div>
              </div>
              <div class="container-offer">
                <p class="pvp-title">{{ transPeralbaPro.item882 }}</p>
                <p class="pvp-offer red">{{ product.price_ | currency }}</p>
              </div>
            </div>
            <div class="container-offer" v-else>
              <p class="pvp-title">{{ transPeralbaPro.item132 }}</p>
              <p class="pvp-offer">{{ product.price | currency }}</p>
            </div>
          </div>
        </a>
      </div>

      <a
        class="btn-per-view-results"
        v-if="products.length > 1"
        role="button"
        @click="search()"
        >{{ transPeralbaPro.item885 }}<i class="fas fa-chevron-right ms-3"></i>
      </a>
    </div>
  </div>
</template>
<script>
import axios from "axios";
// import ProductItem from "./components/ProductItem";
// import PageControl from "./components/PageControl";
export default {
  name: "suggestions",
  props: [
    "routesearch",
    "routesug",
    "routepro",
    "routecat",
    "keywords",
    "activity",
    "user",
    "transMenu",
    "transPeralbaPro",
  ],
  filters: {
    uppercase: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
    currency(value) {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    percentage(value) {
      if (parseInt(value) == parseFloat(value)) {
        return parseInt(value) + "%";
      } else {
        return parseFloat(value).toFixed(2) + "%";
      }
    },
  },
  data() {
    return {
      // expandedKeys: [],
      // checkedBrandsKeys: [],
      // filteredByBrand: [],
      // filteredByCategory: [],
      suggestions: [],
      categories: [],
      products: [],
      // keywords: "jijiji",
      order: undefined,
    };
  },
  computed: {},

  watch: {
    activity: function(newVal, oldVal) {
      this.getResults();
    },
    keywords: {
      handler: debounce(function(newVal) {
        this.getResults();
      }, 750),
      deep: true,
      immediate: true,
    },
    // keywords:debounce(function (newVal) {
    // this.getResults();
    // }, 750),
  },
  mounted() {
    let vm = this;
  },
  methods: {
    getResults() {
      const csrf = document.getElementById("csrf-token");

      axios
        .post(this.routesug, {
          q: this.keywords,
          _token: csrf,
        })
        .then((r) => {
          console.log("result get suggestions =>");
          console.log(r);
          this.suggestions = r.data.results;
        })
        .catch((e) => {
          console.log("error get suggestions =>");
          console.log(e);
        });

      axios
        .post(this.routecat, {
          q: this.keywords,
          _token: csrf,
        })
        .then((r) => {
          console.log("result get categories =>");
          console.log(r);
          this.categories = r.data.results;
        })
        .catch((e) => {
          console.log("error get categories =>");
          console.log(e);
        });

      let vm2 = this;

      axios
        .post(this.routepro, {
          q: this.keywords,
          activity: this.activity,
          _token: csrf,
        })
        .then((r) => {
          console.log("result get products =>");
          console.log(r);
          // console.log("user...");
          // console.log(this.user);
          this.products = r.data.results;
          // if (this.user && this.user.id !== 2) {
          console.log("user.... ");
          this.products.forEach(function(product) {
            // if (!product.prices) {
            axios
              .get("/get-product-price/" + product.id)
              .then((result) => {
                console.log(result.data.prices);
                if (result.data.prices) {
                  vm2.handleUpdatePrice(result.data.prices, product);
                  console.log(result.data.prices);
                  product.price_ = result.data.prices.price;
                  product.discount_ = result.data.prices.discount;
                  product.price_without_discount_ =
                    result.data.prices.price_without_discount;
                }
              })
              .catch((e) => {
                console.log(e);
              })
              .finally(() => console.log("finish..."));
            // }
          });
          // }
        })
        .catch((e) => {
          console.log("error get products =>");
          console.log(e);
        });
    },

    search() {
      window.location.href = this.routesearch + "?q=" + this.keywords;
    },

    sendToSearch(value) {
      window.location.href = this.routesearch + "?q=" + value;
    },

    checkSearcherInputEmpty() {
      let value = $("#input-header-searcher").val();

      if (value.length > 0) {
        $("#row-searches").addClass("d-none");
        $("#row-suggestions").removeClass("d-none");
      } else {
        $("#row-searches").removeClass("d-none");
        $("#row-suggestions").addClass("d-none");
      }
    },

    handleUpdatePrice(prices, product) {
      this.$set(product, "price_", prices.price);
      this.$set(
        product,
        "price_without_discount_",
        prices.price_without_discount
      );
      this.$set(product, "discount_", prices.discount);
    },
  },
};

function debounce(fn, delay) {
  var timeoutID = null;
  return function() {
    clearTimeout(timeoutID);
    var args = arguments;
    var that = this;
    timeoutID = setTimeout(function() {
      fn.apply(that, args);
    }, delay);
  };
}
</script>
